export const META_TYPE = 'cmcFear';
export const META_VER = 'v1';

export const CMD_FEARGREED_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
